export default "__VITE_ASSET__723f27c8__"